import React, {useContext, useState} from 'react';
import './TextInput.scss';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {I18nContext} from "../../contexts/i18nContext";
import {ToastContext} from "../../contexts/toastContext";
import {constructClassNames, convertValueToCurrency} from "../../helpers/helpers";

const TextInput = (
  {
    name,
    type='text',
    value,
    onChange,
    onBlur,
    onKeyDown,
    label,
    placeholder,
    required,
    error,
    disabled,
    area,
    link,
    validateAsCurrency,
    mini
  }
) => {
  const { t } = useContext(I18nContext);
  const { displayToast } = useContext(ToastContext);
  const [currentType, setCurrentType] = useState(type);

  const toggleShowPassword = () => {
    setCurrentType(currentType === 'password' ? 'text' : 'password');
  };

  const copyToClipboard = async text => {
    try {
      await navigator.clipboard.writeText(text);
      displayToast('success', t('copied to clipboard'));
    } catch (err) {
      displayToast('error', t('could not copy to clipboard'));
    }
  };

  const inputFieldClasses = [
    {name: 'disabled', condition: !!disabled},
    {
      name: 'emptyRequired',
      condition: type === 'number'
        ? (!value && value !== 0) && required
        : (!value || !value?.length) && required
    },
    {name: 'linkField', condition: !!link}
  ];

  return (
    <div className={mini ? 'TextInput--mini' : 'TextInput'}>
      {!!label && (
        <label className='inputLabel'>
          {label}{required ? '*' : ''}
        </label>
      )}
      {!area
        ? (
          <input
            className={error
              ? 'inputFieldError'
              : constructClassNames('inputField', inputFieldClasses)
            }
            type={currentType}
            value={value}
            onChange={e =>
              onChange(name, e.target.value)
            }
            onBlur={onBlur
              ? e =>
                onBlur(name, validateAsCurrency ? convertValueToCurrency(e.target.value) : e.target.value)
              : e =>
                onChange(name, validateAsCurrency ? convertValueToCurrency(e.target.value) : e.target.value, false, true, 'text')
            }
            onKeyDown={e => !!onKeyDown ? onKeyDown(e) : null}
            style={{paddingRight: type === 'password' ? '100px' : link ? '30px' : '5px'}}
            placeholder={placeholder}
            disabled={disabled}
          />
        ) : (
          <textarea
            className={error
              ? 'inputFieldError inputFieldArea'
              : `inputField inputFieldArea ${!!disabled ? 'inputField--disabled' : ''}`
            }
            value={value}
            onChange={e => onChange(name, e.target.value)}
            onBlur={onBlur
              ? e => onBlur(name, e.target.value)
              : e => onChange(name, e.target.value, false, true, 'text')}
            onKeyDown={e => !!onKeyDown ? onKeyDown(e) : null}
            style={{paddingRight: type === 'password' ? '100px' : '5px'}}
            placeholder={placeholder}
            disabled={disabled}
          />
        )
      }
      {type === 'password' && (
        <div className='showPasswordButton' onClick={toggleShowPassword}>
          {currentType === 'password' ? <VisibilityIcon /> : <VisibilityOffIcon />}
        </div>
      )}
      {!!link && !!value && (
        <div className='copyToClipboardButton' onClick={() => copyToClipboard(value)}>
          <ContentCopyIcon />
        </div>
      )}
    </div>
  );
}

export default TextInput;
